var exports = {
  "k": "xe7b6e3d6--bb9e82--container",
};

module.exports = exports;
